import React from "react";
import { Button } from "antd";
import useAiAssessmentQuestionNavigation from "../../hooks/useAiAssessmentQuestionNavigation";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";

const AiAssessmentQuestionActions: React.FC = () => {
  const {
    currentStep,
    isFullscreen,
    isRoundFinished,
    temporaryAnswer,
    aiAssessmentQuestions,
  } = useAIAssessmentContext();

  const { navigateToNextQuestion, navigateToPreviousQuestion } =
    useAiAssessmentQuestionNavigation();

  const isMarginTopAuto = !isFullscreen && isRoundFinished;
  const currentQuestion = aiAssessmentQuestions[currentStep];

  const getNextButtonText = () => {
    if (isRoundFinished) {
      return "Next";
    } else {
      if (temporaryAnswer && temporaryAnswer.trim().length > 0) {
        const questionType = currentQuestion?.answerType.toLowerCase();
        if (questionType === "coding") {
          return "Submit Code";
        } else {
          return "Submit";
        }
      } else {
        return "Next";
      }
    }
  };

  if (!currentQuestion) return null;
  return (
    <div
      className={"ai-assessment-question-actions"}
      style={{ marginTop: isMarginTopAuto ? "auto" : "0px" }}
    >
      <Button
        type="default"
        onClick={navigateToPreviousQuestion}
        disabled={currentStep === 0}
      >
        Previous
      </Button>
      <Button type="primary" onClick={navigateToNextQuestion}>
        {getNextButtonText()}
      </Button>
    </div>
  );
};

export default AiAssessmentQuestionActions;
